module.exports = __webpack_public_path__ + "img/game1.5654aa79.png";